import Loadable from "../../../components/Loadable";

const DaftarPengumumanView = Loadable(() => import("./DaftarPengumumanView"));
const DetilPengumumanView = Loadable(() => import("./DetilPengumumanView"));

export default {
  DetilPengumumanView,
  DaftarPengumumanView,
};
